import React, { useEffect } from 'react';
import './Toast.css';

function Toast({ type = 'info', message, title, onConfirm, onCancel, onClose, autoClose = true, duration = 3000 }) {
  useEffect(() => {
    if (autoClose && type !== 'confirm') {
      const timer = setTimeout(() => {
        onClose?.();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [autoClose, duration, onClose, type]);

  const getIcon = () => {
    switch (type) {
      case 'success':
        return '✓';
      case 'error':
        return '✕';
      case 'confirm':
        return '?';
      case 'info':
      default:
        return 'ℹ';
    }
  };

  const getIconClass = () => {
    return `toast-icon toast-icon-${type}`;
  };

  return (
    <div className={`toast toast-${type}`}>
      <div className="toast-content">
        <div className={getIconClass()}>
          {getIcon()}
        </div>
        <div className="toast-message">
          {title && <strong className="toast-title">{title}</strong>}
          <p className="toast-text">{message}</p>
        </div>
        {type !== 'confirm' && (
          <button className="toast-close" onClick={onClose}>
            ✕
          </button>
        )}
      </div>
      {type === 'confirm' && (
        <div className="toast-actions">
          <button className="toast-button toast-btn-cancel" onClick={onCancel}>
            취소
          </button>
          <button className="toast-button toast-btn-confirm" onClick={onConfirm}>
            확인
          </button>
        </div>
      )}
    </div>
  );
}

export default Toast;
